import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import { PageHero, SectionHead } from "../components/site/PageHero";
import { Reveal } from "../components/site/Reveal";
import { AffiliationBlock } from "../components/site/Sections";

const WHY = [
  { title: "Organised labour representation", text: "Individual employees often find it difficult to raise concerns alone. Organised representation gives IT employees a collective, credible voice." },
  { title: "Collective bargaining", text: "Collective bargaining enables employees to engage with employers on wages, working conditions and policies from a position of unity." },
  { title: "Employee protection", text: "Being part of an established trade union network means employees have access to guidance and support when facing workplace issues." },
  { title: "Democratic trade union participation", text: "Members participate in a democratic process — electing representatives, raising issues and shaping the federation's priorities." },
];

export default function Affiliation() {
  return (
    <>
      <PageHero eyebrow="Our Affiliation" title="Affiliated to STU" subtitle="Swatantra Thozhilali Union – a registered trade union associated with the Indian Union Muslim League (IUML)." image="/images/kozhikode-boat.jpg" testId="affiliation-hero" />
      <section className="bg-slate-100/70 py-16 md:py-24"><div className="container-x"><AffiliationBlock /></div></section>
      <section className="py-16 md:py-24">
        <div className="container-x">
          <SectionHead eyebrow="Why it matters" title="The importance of organised labour" />
          <div className="mt-10 grid gap-6 md:grid-cols-2">
            {WHY.map((w, i) => (
              <Reveal key={w.title} delay={i * 0.06}>
                <div className="h-full rounded-xl border border-slate-200 bg-white p-8" data-testid={`affiliation-why-${i}`}>
                  <span className="font-mono text-sm text-leaf">0{i + 1}</span>
                  <h3 className="mt-3 font-display text-xl font-bold text-navy">{w.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-600">{w.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-10 flex items-start gap-3 rounded-xl border border-royal/20 bg-royal-light/50 p-5 text-sm text-slate-700" data-testid="affiliation-note">
            <Info className="h-5 w-5 shrink-0 text-royal" />
            <p>Registration credentials will be displayed here after verification. For enquiries regarding the affiliation, please <Link to="/contact" className="font-semibold text-royal underline">contact the federation office</Link>.</p>
          </div>
        </div>
      </section>
    </>
  );
}
